import React, {useEffect, useState} from 'react';
import {Flex, Scrollbar, Title} from '@priority-software/priority-style-react';
import {FormHelpHeader, Loader, OpenInExpert, XpertError} from '../FormHelpUI';
import texts from '../../texts';
import {getDetails, openInXpertById} from '../../actions/helpActions';
import styles from '../../styles/FormHelpDialog.module.scss';
import {observer} from 'mobx-react';
import {HTMLText} from '../../../../components/Common/HtmlText/HTMLText';

export type DetailsPageProps = {
    id: string;
    removeHelpPage: () => void;
};

export const DetailsPage = observer(({id, removeHelpPage}: DetailsPageProps) => {
    const [item, setItem] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (!isLoading) {
            setIsLoading(true);
        }
        getDetails(id).then(data => {
            if (data) {
                setItem({title: data.title, html: data?.html});
            }
            setIsLoading(false);
        });
    }, [id]);

    return (
        <Flex direction="column" justifyContent="flex-start" componentClasses={styles.container}>
            <FormHelpHeader onBackClick={() => removeHelpPage()} topTitle={texts.back} />
            {!isLoading ? (
                item ? (
                    <>
                        <Scrollbar componentClasses={styles.scrollContainer}>
                            <div className={styles.detailsContainer}>
                                <Title skin="h2" textColor="primary-700" fontWeight="thin">
                                    {item?.title}
                                </Title>
                                <div className={styles.detailsHtml}>
                                    <HTMLText content={item?.html} />
                                </div>
                            </div>
                        </Scrollbar>

                        <Flex componentClasses={styles.footer}>
                            <OpenInExpert onClick={() => openInXpertById(id)} />
                        </Flex>
                    </>
                ) : (
                    <XpertError />
                )
            ) : (
                <Loader />
            )}
        </Flex>
    );
});
